import { render, staticRenderFns } from "./LoanFields.vue?vue&type=template&id=e3860d1c"
import script from "./LoanFields.vue?vue&type=script&lang=js"
export * from "./LoanFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports